import { render, staticRenderFns } from "./LPopper.vue?vue&type=template&id=519bc295&"
import script from "./LPopper.vue?vue&type=script&lang=js&"
export * from "./LPopper.vue?vue&type=script&lang=js&"
import style0 from "./LPopper.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports